import { Component, computed, Inject, signal } from '@angular/core';
import { form, FormField, min, required } from '@angular/forms/signals';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatInputModule } from '@angular/material/input';
import { MceSaveCancelComponent, MceSaveCancelConfig, MceSaveCancelEvent } from '../../components/mce-save-cancel/mce-save-cancel.component';

export interface ImpedanceZXRRatio {
  z: number;
  xrRatio: number;
}

@Component({
  selector: 'app-impedance-z-xr-ratio',
  imports: [FormField, MatDialogModule, MatInputModule, MceSaveCancelComponent],
  templateUrl: './impedance-z-xr-ratio.component.html',
})
export class ImpedanceZXRRatioComponent {

  formModel = signal<ImpedanceZXRRatio>({
    z: 0,
    xrRatio: 1
  });

  form = form(this.formModel, path => {
    required(path.z, { message: 'Impedance magnitude is required' });
    min(path.z, 0, { message: 'Impedance magnitude cannot be negative' });
    required(path.xrRatio, { message: 'X/R ratio is required' });
  });

  constructor(
    public dialogRef: MatDialogRef<ImpedanceZXRRatioComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { title: string }
  ) { }

  inputData = computed(() => this.data);

  readonly saveCancelConfig = computed<MceSaveCancelConfig>(() => ({
    save: { show: true, enable: this.form().valid() },
    cancel: { show: true, enable: true }
  }));

  onSaveClick(): void {
    this.dialogRef.close(this.form().value());
  }

  onCancelClick(): void {
    this.dialogRef.close();
  }

  onSaveCancelAction(event: MceSaveCancelEvent): void {
    if (event.type === 'save') {
      this.onSaveClick();
      return;
    }

    if (event.type === 'cancel') {
      this.onCancelClick();
    }
  }
}
